import { ChevronLeftIcon } from "lucide-react";
import { Link } from "react-router";

import { Row } from "@/components/Row";
import { sidebarNavigationStore } from "@/stores/sidebarNavigation";

export const ParentSidebarBackButton = () => {
  const parentRoute = sidebarNavigationStore((state) => state.parentRoute);

  return (
    <Link
      className="group -ml-2 inline-flex w-fit items-center gap-1 rounded-md px-2 py-1 text-sm font-semibold text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-700"
      to={parentRoute.path}
    >
      <Row className="ml-[-1px] items-center">
        <ChevronLeftIcon className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" />
      </Row>
      Back to {parentRoute.label}
    </Link>
  );
};
